import React from "react"

import SectionContainer from "../components/SectionContainer"
import BookTag from "../components/BookTag"

const PragramaticProgrammerTag = () => 
  <BookTag
    book="The Pragmatic Programmer"
    author="Andy Hunt and Dave Thomas"
  />

  
  const Gangof4Tag = () => 
  <BookTag
  book="Design Patterns"
  author='"The Gang of Four"'
  />
  
const ArchitectureTag = () =>
  <BookTag
    book="Software Architecture in Practice"
    author="Len Bass, Paul Clements, and Rick Kazman"
  />

const EnterprisePatternsTag = () => 
  <BookTag
    book="Patterns of Enterprise Application Architecture"
    author="Martin Fowler"
  />

const PosaTag = () =>
  <BookTag
    book="Pattern Oriented Software Architecture"
    author="Buschmann, Meunier, Rohnert, Sommerlad and Stal"
  />

const RefactorTag = () => 
  <BookTag
    book="Refactoring"
    author='Kent Beck and Martin Fowler'
  />

const SicpTag = () => 
  <BookTag
    book="Structure and Interpretation of Computer Programs"
    author="Gerald Jay Sussman and Hal Abelson"
  />

const AITag = () =>
  <BookTag
    book="Artificial Intelligence: A Modern Approach"
    author="Peter Norvig and Stuart J. Russell"
  />

const GameAITag = () =>
  <BookTag
    book="Programming Game AI by Example"
    author="Mat Buckland"
  />

// Full section
const BooksSection = () => (
  <SectionContainer header="My Favorite Books">
    <PragramaticProgrammerTag/>
    <Gangof4Tag/>
    <ArchitectureTag/>
    <PosaTag/>
    <EnterprisePatternsTag/>
    <RefactorTag/>
    <AITag/>
    <GameAITag/>
    <SicpTag/>
  </SectionContainer>
)

export default BooksSection
